import React from "react";

import { ButtonTypeMap } from "@mui/material";
import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";

import { MESSAGING_BOT_PROVIDERS_BY_ID } from "@app/common/constants/providers";
import type { MessagingBotProviderId } from "@app/common/types/providerTypes";

import Button, { ButtonProps } from "@rui/Button";

type AppProviderButtonProps<
  P extends React.ElementType = ButtonTypeMap["defaultComponent"],
> = ButtonProps<P> & { provider: MessagingBotProviderId };

const AppProviderButton = styled(
  <P extends React.ElementType = ButtonTypeMap["defaultComponent"]>({
    provider,
    ...props
  }: AppProviderButtonProps<P>) => {
    const providerIcon = MESSAGING_BOT_PROVIDERS_BY_ID[provider].icon;
    return (
      <Button
        startIcon={
          <Box
            component="img"
            src={providerIcon}
            sx={{
              width: "20px",
              height: "20px",
              filter: props.disabled ? "grayscale(100%)" : undefined,
            }}
          />
        }
        variant="outlined"
        {...props}
      />
    );
  }
)(({ theme }) => ({
  borderColor: theme.palette.shades.neutral[150],
  backgroundColor: "#fff",
  color: theme.palette.shades.neutral[800],
}));

export default AppProviderButton;
